import { useState } from "react";
import Toast from "./Toast";

export default function ProfessionalForm({ professional }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("tipo", "profesional");
    formData.append("name", name);
    formData.append("email", email);
    formData.append("message", message);
    formData.append("para", professional.email);
    formData.append("profesional_nombre", professional.name);
   
    const response = await fetch("https://fariaslegal.ar/sendmail.php", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setSent(true);
      setTimeout(() => setSent(false), 3000);

      setName("");
      setEmail("");
      setMessage("");
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-xl shadow-md max-w-lg mx-auto"
      >
        <h3 className="text-xl font-semibold mb-4">
          Contactar a {professional.name}
        </h3>

        <input
          type="text"
          placeholder="Tu nombre"
          className="border p-2 rounded w-full mb-3"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          type="email"
          placeholder="Tu email"
          className="border p-2 rounded w-full mb-3"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <textarea
          placeholder="Mensaje"
          className="border p-2 rounded w-full mb-3 h-32"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        />

        <button
          type="submit"
          className="bg-primary text-white px-4 py-2 rounded hover:bg-primary/90"
        >
          Enviar
        </button>
      </form>

      <Toast message="Mensaje enviado. Pronto responderemos." show={sent} />
    </>
  );
}
